import { call, put, takeEvery, fork } from "redux-saga/effects";
import * as types from "./ProviderCapacityInputActionType";
import * as actions from "./ProviderCapacityInputAction";
import * as services from "./ProviderCapacityInputServices";
import SweetAlert from "../../../../components/sweetalert/SweetAlert";

function* fetchProviderCapacitiesSaga(action) {
  try {
    const filterParams = action.payload || {};
    const response = yield call(services.getProviderCapacities, filterParams);
    if (response?.success) {
      yield put(actions.fetchCapacityInputSuccess(response.values || {}));
    } else {
      yield put(actions.fetchCapacityInputFailure("No data found"));
    }
  } catch (error) {
    console.error("Capacity Input Fetch Error:", error);
    yield put(
      actions.fetchCapacityInputFailure("Failed to fetch capacity input data"),
    );
    SweetAlert.error({
      title: "Error!",
      text: "Failed to load Capacity Input Data",
    });
  }
}

function* fetchCapacityFiltersSaga() {
  try {
    const response = yield call(services.getProviderCapacityFilters);
    if (response?.success) {
      yield put(actions.fetchCapacityFiltersSuccess(response.values || {}));
    } else {
      yield put(actions.fetchCapacityFiltersFailure("No filter data found"));
    }
  } catch (error) {
    console.error("Capacity Filters Fetch Error:", error);
    yield put(actions.fetchCapacityFiltersFailure("Failed to fetch capacity filters"));
  }
}

function* fetchDefaultRadCapacitySaga() {
  try {
    const response = yield call(services.getDefaultRadCapacity);
    if (response?.success) {
      yield put(actions.fetchDefaultRadCapacitySuccess(response.values || {}));
    } else {
      yield put(actions.fetchDefaultRadCapacityFailure("No data found"));
    }
  } catch (error) {
    console.error("Default Provider Capacity Fetch Error:", error);
    yield put(
      actions.fetchDefaultRadCapacityFailure(
        "Failed to fetch default Provider capacity",
      ),
    );
    SweetAlert.error({
      title: "Error!",
      text: "Failed to load Default Provider Capacity Data",
    });
  }
}

function* updateRadCapacityInputSaga(action) {
  try {
    const response = yield call(
      services.updateRadCapacityInput,
      action.payload,
    );

    if (response?.success) {
      yield put(actions.updateRadCapacityInputSuccess(response.values || {}));

      SweetAlert.success({
        title: "Success!",
        text: response?.resultMessage || "Update successfully.",
      });
      yield put(actions.fetchCapacitiesRequest());
      if (typeof action.onSuccess === "function") {
        action.onSuccess(response);
      }
    } else {
      yield put(actions.updateRadCapacityInputFailure("Update failed"));
      SweetAlert.error({
        title: "Error!",
        text: response?.errorMessage || "Update failed",
      });
    }
  } catch (error) {
    console.error("Update Provider Capacity Input Error:", error);
    yield put(
      actions.updateRadCapacityInputFailure(
        "Failed to update Provider capacity input",
      ),
    );
    SweetAlert.error({
      title: "Error!",
      text: "Failed to update Provider Capacity Input",
    });
  }
}

function* bulkUpdateRadCapacityInputSaga(action) {
  try {
    const response = yield call(
      services.bulkUpdateRadCapacityInput,
      action.payload,
    );
    if (response?.success) {
      yield put(
        actions.bulkUpdateRadCapacityInputSuccess(response.values || {}),
      );

      SweetAlert.success({
        title: "Success!",
        text: response?.resultMessage || "Bulk Update successfully.",
      });
      yield put(actions.fetchCapacitiesRequest(action.filters || {}));
    } else {
      yield put(
        actions.bulkUpdateRadCapacityInputFailure("Bulk update failed"),
      );
      SweetAlert.error({
        title: "Error!",
        text: response?.errorMessage || "Bulk update failed",
      });
    }
  } catch (error) {
    console.error("Bulk Update Provider Capacity Input Error:", error);
    yield put(
      actions.bulkUpdateRadCapacityInputFailure(
        "Failed to bulk update Provider capacity input",
      ),
    );
    SweetAlert.error({
      title: "Error!",
      text: "Failed to bulk update Provider Capacity Input",
    });
  }
}

function* radCapacityIpUploadSaga(action) {
  const { formData, onSuccess } = action.payload;

  try {
    const response = yield call(services.radCapacityIpUpload, formData);

    if (response?.success) {
      yield put(actions.radCapacityIpUploadSuccess(response.values || {}));

      SweetAlert.success({
        title: "Success!",
        text: response?.resultMessage || "File Uploaded successfully.",
      });

      yield put(actions.fetchCapacitiesRequest());

      if (onSuccess) onSuccess(); // ✅ CLOSE MODAL HERE
    } else {
      yield put(actions.radCapacityIpUploadFailure("File upload failed"));
      SweetAlert.error({
        title: "Error!",
        text: response?.errorMessage || "File upload failed",
      });
    }
  } catch (error) {
    yield put(actions.radCapacityIpUploadFailure("Failed to upload file"));
    SweetAlert.error({ title: "Error!", text: "Failed to upload file" });
  }
}

export default function* watchCapacityInputSaga() {
  yield takeEvery(
    types.FETCH_CAPACITY_INPUT_NEW_REQUEST,
    fetchProviderCapacitiesSaga,
  );
  yield takeEvery(
    types.FETCH_CAPACITY_FILTERS_NEW_REQUEST,
    fetchCapacityFiltersSaga,
  );
  yield takeEvery(
    types.FETCH_DEFAULT_RAD_CAPACITY_NEW_REQUEST,
    fetchDefaultRadCapacitySaga,
  );
  yield takeEvery(
    types.UPDATE_RAD_CAPACITY_INPUT_NEW_REQUEST,
    updateRadCapacityInputSaga,
  );
  yield takeEvery(
    types.BULK_UPDATE_RAD_CAPACITY_INPUT_NEW_REQUEST,
    bulkUpdateRadCapacityInputSaga,
  );
  yield takeEvery(
    types.RAD_CAPACITY_IP_UPLOAD_NEW_REQUEST,
    radCapacityIpUploadSaga,
  );
}
